/**
 * Enumeration class for Nationality
 */
export enum Nationality {
    
        "residente"
        ,
    
        "estrangeiro"
        
    
}
